import axios from "axios";
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function isHtmlResponse(data) {
    return typeof data === "string" && /^\s*<!doctype html/i.test(data);
}

export default {
    install: app => {
        const store = app.config.globalProperties.$store;
        const auth = app.config.globalProperties.$auth0;

        axios.defaults.headers.common["x-timezone"] = timeZone;

        const dataErrorHandler = async err => {
            console.log(err);
            if (!err.response) return Promise.reject(err);
            let retry, reload;
            switch (err.response.status) {
                case 401:
                    if (!store.state.hasToken) {
                        return Promise.reject(err);
                    }
                    retry = window.confirm("You appear to be logged out. Try auto-login?");
                    if (!retry) {
                        return Promise.reject(err);
                    } // prevents loop
                    console.log("invalid user; attempting relogin");
                    auth.logout({ returnTo: window.location.origin });
                    break;
                case 404:
                    reload = window.confirm("ERROR: fetching data for: \n" + err.request.responseURL + " \n\nReload Page?");
                    if (!reload) {
                        return Promise.reject(err);
                    } // prevents loop
                    window.location.reload();
            }
            return Promise.reject(err);
        };

        axios.interceptors.response.use(res => {
            if (isHtmlResponse(res.data)) {
                const url = res.config?.url ?? "unknown";
                console.error("API returned HTML instead of JSON:", url);
                return Promise.reject(
                    Object.assign(new Error(`API returned HTML instead of JSON: ${url}`), {
                        response: res,
                        config: res.config,
                    }),
                );
            }
            return res;
        }, dataErrorHandler);

        const plain = axios.create();
        const init = () => {
            axios.defaults.baseURL = store.state.apiUrl + store.state.apiEndpoint;
            if (store.state.hasToken) {
                axios.defaults.headers.common["Authorization"] = `Bearer ${store.state.hasToken}`;
            } else {
                delete axios.defaults.headers.common["Authorization"];
            }
        };
        const setAuthToken = token => {
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        };
        app.config.globalProperties.$axios = {
            init,
            setAuthToken,
            plain,
        };
    },
};
